function showConfirmModal(opts, callback) {
    $('#confirmIcon').html(opts.icon).css('color', opts.color || '#333');
    $('#confirmTitle').text(opts.title);
    $('#confirmMessage').text(opts.message);
    $('#confirmBtn').attr('class', 'btn btn-sm px-4 ' + (opts.btnClass || 'btn-primary')).text(opts.btnText || 'Confirm');
    $('#confirmBtn').off('click').on('click', function() {
        $('#confirmModal').modal('hide');
        callback();
    });
    $('#confirmModal').modal('show');
}

function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}

function renderWorkflowTimeline(snapshot) {
    var nodes = snapshot.nodes || [];
    var connections = snapshot.connections || [];

    var nodeMap = {};
    nodes.forEach(function(n) { nodeMap[n.id] = n; });
    var adjList = {};
    connections.forEach(function(c) {
        var src = c.source || c.from;
        var tgt = c.target || c.to;
        if (!adjList[src]) adjList[src] = [];
        adjList[src].push(tgt);
    });
    var triggerNode = nodes.find(function(n) { return n.type === 'trigger'; });
    var ordered = [];
    if (triggerNode) {
        var visited = {};
        var queue = [triggerNode.id];
        visited[triggerNode.id] = true;
        while (queue.length) {
            var curr = queue.shift();
            ordered.push(nodeMap[curr]);
            (adjList[curr] || []).forEach(function(t) {
                if (!visited[t]) { visited[t] = true; queue.push(t); }
            });
        }
    } else {
        ordered = nodes;
    }

    var displayNodes = ordered.filter(function(n) { return n.type !== 'trigger'; });
    if (!displayNodes.length) return '<div class="text-muted text-center py-3"><i class="fad fa-stream fa-2x mb-2 d-block"></i>No workflow nodes</div>';

    var dotColors = { delay: '#f59e0b', condition: '#3b82f6', action: '#10b981' };
    var dotIcons = { delay: 'fa-clock', condition: 'fa-question-circle', action: 'fa-cog' };
    var typeClasses = { delay: 'wf-type-delay', condition: 'wf-type-condition' };
    var friendlyTypes = {
        delay: 'Delay', condition: 'Condition',
        send_email: 'Send Email', send_whatsapp: 'WhatsApp', send_wabot: 'WABot', send_wasapbot: 'WasapBot',
        add_to_smsniaga: 'SMS Niaga', add_to_mailniaga: 'Mail Niaga',
        add_to_googlesheets: 'Google Sheets', webhook: 'HTTP Request'
    };
    var typeIcons = {
        delay: 'fa-clock', condition: 'fa-question-circle',
        send_email: 'fa-envelope', send_whatsapp: 'fa-comment-dots', send_wabot: 'fa-paper-plane', send_wasapbot: 'fa-comment-alt',
        add_to_smsniaga: 'fa-sms', add_to_mailniaga: 'fa-at',
        add_to_googlesheets: 'fa-table', webhook: 'fa-bolt'
    };

    var out = '';
    if (triggerNode) {
        var tData = triggerNode.data || {};
        var tLabel = tData.label || triggerNode.label || 'Trigger';
        var triggerDesc = (tData.trigger_type || '').replace(/_/g, ' ');
        out += '<div class="d-flex align-items-center mb-3 pb-3 border-bottom">';
        out += '<div class="mr-3" style="width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,#6366f1,#818cf8);display:flex;align-items:center;justify-content:center;flex-shrink:0"><i class="fad fa-bolt text-white" style="font-size:14px"></i></div>';
        out += '<div><div class="font-weight-bold text-14">' + tLabel + '</div>';
        if (triggerDesc) out += '<div class="text-muted text-12">' + triggerDesc + '</div>';
        out += '</div></div>';
    }

    out += '<div class="wf-timeline">';

    displayNodes.forEach(function(node, idx) {
        var d = node.data || {};
        var nodeType = node.type || 'action';
        var actionType = d.action_type || nodeType;
        var label = d.label || node.label || friendlyTypes[actionType] || actionType;
        var dotColor = dotColors[nodeType] || '#8b5cf6';
        var dotIcon = typeIcons[actionType] || dotIcons[nodeType] || 'fa-cog';
        var typeClass = typeClasses[nodeType] || 'wf-type-action';
        var friendlyType = friendlyTypes[actionType] || (actionType.charAt(0).toUpperCase() + actionType.slice(1));
        var tIcon = typeIcons[actionType] || 'fa-cog';
        var detailId = 'wf_detail_' + idx;
        var stepNum = idx + 1;

        var summaryLines = [];
        switch (actionType) {
            case 'delay':
                if (d.delay_type === 'until') {
                    summaryLines.push({icon: 'fa-calendar-alt', text: 'Until ' + (d.delay_value || '-')});
                } else {
                    summaryLines.push({icon: 'fa-hourglass-half', text: 'Wait ' + (d.delay_value || '?') + ' ' + (d.delay_unit || 'minutes')});
                }
                break;
            case 'condition':
                if (d.conditions && d.conditions.length) {
                    summaryLines.push({icon: 'fa-filter', text: 'Logic: ' + (d.condition_logic || 'AND')});
                    d.conditions.forEach(function(c) {
                        var op = (c.operator || '').replace(/_/g, ' ');
                        summaryLines.push({icon: 'fa-equals', text: (c.field || '?') + ' ' + op + ' ' + (c.value || '')});
                    });
                }
                break;
            case 'send_email':
                if (d.email_to) summaryLines.push({icon: 'fa-at', text: 'To: ' + d.email_to});
                if (d.email_subject) summaryLines.push({icon: 'fa-heading', text: 'Subject: ' + d.email_subject});
                break;
            case 'send_whatsapp': case 'send_wabot': case 'send_wasapbot':
                var phone = d.whatsapp_to || d.wabot_to || d.wasapbot_to || d.to_number || '{phone}';
                summaryLines.push({icon: 'fa-phone', text: 'To: ' + phone});
                break;
            case 'add_to_smsniaga':
                summaryLines.push({icon: 'fa-phone', text: 'To: ' + (d.subscriber_phone || d.sms_phone || '{phone}')});
                if (d.sms_sender_id) summaryLines.push({icon: 'fa-id-badge', text: 'Sender: ' + d.sms_sender_id});
                break;
            case 'add_to_mailniaga':
                if (d.mailniaga_email) summaryLines.push({icon: 'fa-at', text: 'Email: ' + d.mailniaga_email});
                if (d.mailniaga_version) summaryLines.push({icon: 'fa-code-branch', text: 'Version: ' + d.mailniaga_version.toUpperCase()});
                if (d.mailniaga_list_id) summaryLines.push({icon: 'fa-list', text: 'List: ' + d.mailniaga_list_id});
                break;
            case 'add_to_googlesheets':
                if (d.spreadsheet_id) summaryLines.push({icon: 'fa-table', text: 'Sheet: ' + d.spreadsheet_id});
                break;
            case 'webhook':
                summaryLines.push({icon: 'fa-link', text: (d.webhook_method || 'POST') + ' ' + (d.webhook_url || '-')});
                break;
        }

        var detailContent = '';
        if (actionType === 'send_email' && d.email_body) {
            detailContent = '<div class="border rounded p-2 bg-white text-12" style="max-height:160px;overflow:auto">' + d.email_body + '</div>';
        } else if (actionType === 'send_whatsapp' && d.whatsapp_message) {
            detailContent = '<pre class="bg-white border rounded p-2 text-12 mb-0" style="max-height:128px;overflow:auto;white-space:pre-wrap">' + escapeHtml(d.whatsapp_message) + '</pre>';
        } else if (actionType === 'send_wabot' && d.wabot_message) {
            detailContent = '<pre class="bg-white border rounded p-2 text-12 mb-0" style="max-height:128px;overflow:auto;white-space:pre-wrap">' + escapeHtml(d.wabot_message) + '</pre>';
        } else if (actionType === 'send_wasapbot' && d.wasapbot_message) {
            detailContent = '<pre class="bg-white border rounded p-2 text-12 mb-0" style="max-height:128px;overflow:auto;white-space:pre-wrap">' + escapeHtml(d.wasapbot_message) + '</pre>';
        } else if (actionType === 'add_to_smsniaga' && d.sms_message) {
            detailContent = '<pre class="bg-white border rounded p-2 text-12 mb-0" style="max-height:128px;overflow:auto;white-space:pre-wrap">' + escapeHtml(d.sms_message) + '</pre>';
        }

        out += '<div class="wf-timeline-item">';
        out += '<div class="wf-timeline-dot" style="background:' + dotColor + '"><i class="fad ' + dotIcon + '"></i></div>';
        out += '<div class="wf-timeline-card">';
        out += '<div class="d-flex align-items-center justify-content-between mb-1">';
        out += '<div class="d-flex align-items-center">';
        out += '<span class="text-muted text-11 mr-2">Step ' + stepNum + '</span>';
        out += '<span class="font-weight-bold text-13">' + label + '</span>';
        out += '</div>';
        out += '<span class="wf-type-badge ' + typeClass + '"><i class="fad ' + tIcon + ' mr-1"></i>' + friendlyType + '</span>';
        out += '</div>';
        if (summaryLines.length) {
            summaryLines.forEach(function(s) {
                out += '<div class="wf-summary-text"><i class="fad ' + s.icon + ' mr-1"></i>' + s.text + '</div>';
            });
        }
        if (detailContent) {
            out += '<a href="javascript:void(0)" class="wf-detail-link btn-toggle-wf-detail" data-target="#' + detailId + '"><i class="fad fa-caret-right mr-1"></i>Show detail</a>';
            out += '<div id="' + detailId + '" class="d-none mt-2">' + detailContent + '</div>';
        }
        out += '</div></div>';
    });

    out += '</div>';
    return out;
}

$(document).ready(function() {
    var csrfToken = $('meta[name=csrf-token]').attr('content');

    $(document).on('click', '.btn-view-detail', function() {
        var url = $(this).data('url');
        var $body = $('#executionDetailBody');

        $body.html('<div class="text-center py-4"><i class="fad fa-spinner-third fa-spin fa-2x text-muted"></i></div>');
        $('#executionDetailModal').modal('show');

        $.getJSON(url, function(data) {
            var statusColors = {completed:'success', success:'success', failed:'danger', running:'info', partial_success:'warning', skipped:'secondary', cancelled:'dark', pending:'primary', delayed:'primary'};
            var sc = statusColors[data.status] || 'light';
            var typeLabels = {
                trigger:'Trigger', condition:'Condition', delay:'Delay',
                send_email:'Email', send_whatsapp:'WhatsApp', send_wabot:'WABot', send_wasapbot:'WasapBot',
                add_to_smsniaga:'SMSNiaga', add_to_mailniaga:'MailNiaga',
                add_to_googlesheets:'Google Sheets', webhook:'Webhook'
            };

            var nodesCount = data.nodes_executed ? data.nodes_executed.length : 0;
            var statusText = (data.status || '-').replace('_', ' ');
            var statusAlertColors = {completed:'alert-success', failed:'alert-danger', running:'alert-info', partial_success:'alert-warning', skipped:'alert-secondary', cancelled:'alert-dark'};
            var sac = statusAlertColors[data.status] || 'alert-secondary';

            var html = '<div class="row no-gutters mb-3" style="border:1px solid #e9ecef;border-radius:6px;overflow:hidden">';
            html += '<div class="col-3" style="padding:12px 14px;border-right:1px solid #e9ecef">';
            html += '<div class="text-muted text-11 mb-1"><i class="fad fa-circle-notch mr-1"></i>Status</div>';
            html += '<div class="alert ' + sac + ' p-1 px-2 text-10 text-uppercase mb-0 d-inline-block">' + statusText + '</div>';
            html += '</div>';
            html += '<div class="col-3" style="padding:12px 14px;border-right:1px solid #e9ecef">';
            html += '<div class="text-muted text-11 mb-1"><i class="fad fa-bolt mr-1"></i>Trigger</div>';
            html += '<div class="text-13">' + escapeHtml(data.trigger_model || '-') + '</div>';
            html += '</div>';
            html += '<div class="col-3" style="padding:12px 14px;border-right:1px solid #e9ecef">';
            html += '<div class="text-muted text-11 mb-1"><i class="fad fa-clock mr-1"></i>Started</div>';
            html += '<div class="text-13">' + escapeHtml(data.started_at || '-') + '</div>';
            html += '</div>';
            html += '<div class="col-3" style="padding:12px 14px">';
            html += '<div class="text-muted text-11 mb-1"><i class="fad fa-check mr-1"></i>Completed</div>';
            html += '<div class="text-13">' + escapeHtml(data.completed_at || '-') + '</div>';
            html += '</div>';
            html += '</div>';

            if (data.error_message) {
                html += '<div class="alert alert-danger py-2 text-13 mb-3"><i class="fad fa-exclamation-triangle mr-1"></i> ' + escapeHtml(data.error_message) + '</div>';
            }

            if (data.status === 'delayed' && data.pending_delays && data.pending_delays.length) {
                html += '<div class="alert alert-primary py-2 px-3 mb-3" style="border-left:4px solid #4a6cf7">';
                html += '<div class="text-13 font-weight-bold mb-1"><i class="fad fa-clock mr-1"></i>Pending Delays (' + data.pending_delays.length + ')</div>';
                data.pending_delays.forEach(function(pd) {
                    var resumeDate = new Date(pd.resume_at);
                    var now = new Date();
                    var diffMs = resumeDate - now;
                    var timeAgo = '';
                    if (diffMs > 0) {
                        var diffMin = Math.floor(diffMs / 60000);
                        if (diffMin < 60) {
                            timeAgo = diffMin + ' min from now';
                        } else if (diffMin < 1440) {
                            timeAgo = Math.floor(diffMin / 60) + ' hours from now';
                        } else {
                            timeAgo = Math.floor(diffMin / 1440) + ' days from now';
                        }
                    } else {
                        timeAgo = 'ready to resume';
                    }
                    var dateStr = resumeDate.toLocaleDateString('en-GB', {day:'2-digit', month:'short', year:'numeric'}) + ' at ' + resumeDate.toLocaleTimeString('en-GB', {hour:'2-digit', minute:'2-digit', second:'2-digit'});
                    html += '<div class="text-12 text-primary">Will resume on ' + dateStr + ' <span class="font-italic">(' + timeAgo + ')</span></div>';
                });
                html += '</div>';
            }

            // Node Execution Details
            if (data.nodes_details && Object.keys(data.nodes_details).length > 0) {
                var nodeKeys = Object.keys(data.nodes_details);
                var workflowNodes = (data.workflow_snapshot && data.workflow_snapshot.nodes) ? data.workflow_snapshot.nodes.filter(function(n) { return n.type !== 'placeholder'; }) : [];
                var totalNodes = workflowNodes.length || nodeKeys.length;
                var completedNodes = nodeKeys.filter(function(k) { return data.nodes_details[k].status === 'success' || data.nodes_details[k].status === 'completed'; }).length;
                var pct = totalNodes > 0 ? Math.round((completedNodes / totalNodes) * 100) : 0;

                var progressText = completedNodes + ' of ' + totalNodes + ' completed (' + pct + '%)';
                var barColor = 'bg-success';

                if (data.status === 'delayed') {
                    barColor = 'bg-primary';
                    progressText = completedNodes + ' of ' + totalNodes + ' completed';
                }

                html += '<div class="mb-3">';
                html += '<div class="d-flex justify-content-between align-items-center mb-1">';
                html += '<span class="text-13"><i class="fad fa-project-diagram mr-1"></i> Node Execution Details</span>';
                html += '<span class="text-muted text-12">' + progressText + '</span>';
                html += '</div>';
                html += '<div class="progress" style="height:6px;"><div class="progress-bar ' + barColor + '" style="width:' + pct + '%"></div></div>';
                html += '</div>';

                html += '<table class="table table-sm mb-3 text-13">';
                html += '<thead class="bg-light"><tr>';
                html += '<th class="text-11 text-uppercase text-muted border-top-0">Node</th>';
                html += '<th class="text-11 text-uppercase text-muted border-top-0" style="width:90px">Type</th>';
                html += '<th class="text-11 text-uppercase text-muted border-top-0 text-center" style="width:90px">Status</th>';
                html += '<th class="text-11 text-uppercase text-muted border-top-0" style="min-width:280px">Response / Error</th>';
                html += '</tr></thead><tbody>';

                // Render executed nodes
                for (var nodeId in data.nodes_details) {
                    var node = data.nodes_details[nodeId];
                    var nodeStatus = node.status;
                    // Override status for the delay node that's currently waiting
                    if (data.status === 'delayed' && nodeId === data.resume_node_id) {
                        nodeStatus = 'delayed';
                    }
                    var nsc = statusColors[nodeStatus] || (nodeStatus === 'success' ? 'success' : 'light');
                    var friendlyType = typeLabels[node.type] || (node.type ? node.type.charAt(0).toUpperCase() + node.type.slice(1) : '-');
                    var displayName = node.label || friendlyType;
                    var responseId = 'resp_' + nodeId.replace(/[^a-zA-Z0-9]/g, '_');

                    html += '<tr>';
                    html += '<td class="align-middle">' + escapeHtml(displayName) + '</td>';
                    html += '<td class="align-middle">' + escapeHtml(friendlyType) + '</td>';
                    html += '<td class="align-middle"><div class="alert alert-' + nsc + ' p-1 text-10 text-uppercase text-center mb-0">' + (nodeStatus || '-') + '</div></td>';
                    html += '<td class="align-middle">';

                    if (node.response) {
                        html += '<a href="javascript:void(0)" class="text-12 btn-toggle-response" data-target="#' + responseId + '"><i class="fad fa-eye mr-1"></i>View Response</a>';
                    } else if (node.error) {
                        html += '<span class="text-danger text-12"><i class="fad fa-exclamation-circle mr-1"></i>' + escapeHtml(node.error) + '</span>';
                    } else {
                        html += '<span class="text-muted">-</span>';
                    }

                    html += '</td></tr>';

                    if (node.response) {
                        html += '<tr id="' + responseId + '" class="d-none">';
                        html += '<td colspan="4" class="p-0 border-top-0">';
                        html += '<pre class="rounded-0 p-3 text-11 mb-0" style="background:#1a1a2e;color:#4ade80;max-height:300px;overflow:auto;white-space:pre-wrap;word-break:break-word">' + escapeHtml(JSON.stringify(node.response, null, 2)) + '</pre>';
                        html += '</td></tr>';
                    }
                }

                // Render delayed (not yet executed) nodes from workflow snapshot
                var executedIds = Object.keys(data.nodes_details);
                var delayedNodes = workflowNodes.filter(function(n) { return !executedIds.includes(n.id); });
                if (delayedNodes.length) {
                    html += '<tr class="bg-light"><td colspan="4" class="py-2 px-2">';
                    html += '<a href="javascript:void(0)" class="text-muted text-11 btn-toggle-delayed-nodes"><i class="fad fa-chevron-down mr-1"></i>Show pending nodes (' + delayedNodes.length + ')</a>';
                    html += '</td></tr>';

                    delayedNodes.forEach(function(pn) {
                        var pType = typeLabels[pn.data && pn.data.action_type] || typeLabels[pn.type] || (pn.type ? pn.type.charAt(0).toUpperCase() + pn.type.slice(1) : '-');
                        html += '<tr class="delayed-node-row d-none" style="opacity:0.5">';
                        html += '<td class="align-middle text-muted">' + escapeHtml(pn.label || pType) + '</td>';
                        html += '<td class="align-middle text-muted">' + escapeHtml(pType) + '</td>';
                        html += '<td class="align-middle"><div class="alert alert-secondary p-1 text-10 text-uppercase text-center mb-0">Pending</div></td>';
                        html += '<td class="align-middle"><span class="text-muted">-</span></td>';
                        html += '</tr>';
                    });
                }

                html += '</tbody></table>';
            }

            // Tabs: Execution Data & Workflow Snapshot
            var hasExecData = data.execution_data && Object.keys(data.execution_data).length > 0;
            var hasWorkflow = data.workflow_snapshot && data.workflow_snapshot.nodes && data.workflow_snapshot.nodes.length > 0;

            if (hasExecData || hasWorkflow) {
                html += '<ul class="nav nav-tabs nav-fill mb-0" role="tablist">';
                if (hasExecData) {
                    html += '<li class="nav-item"><a class="nav-link active text-13" id="tab-exec-data" data-toggle="tab" href="#pane-exec-data" role="tab"><i class="fad fa-database mr-1"></i>Execution Data</a></li>';
                }
                if (hasWorkflow) {
                    html += '<li class="nav-item"><a class="nav-link ' + (!hasExecData ? 'active' : '') + ' text-13" id="tab-workflow" data-toggle="tab" href="#pane-workflow" role="tab"><i class="fad fa-project-diagram mr-1"></i>Workflow Snapshot</a></li>';
                }
                html += '</ul>';

                html += '<div class="tab-content">';
                if (hasExecData) {
                    html += '<div class="tab-pane fade show active" id="pane-exec-data" role="tabpanel">';
                    html += '<pre class="rounded-0 p-3 text-12 mb-0" style="background:#1a1a2e;color:#4ade80;max-height:450px;overflow:auto">' + escapeHtml(JSON.stringify(data.execution_data, null, 2)) + '</pre>';
                    html += '</div>';
                }
                if (hasWorkflow) {
                    html += '<div class="tab-pane fade ' + (!hasExecData ? 'show active' : '') + '" id="pane-workflow" role="tabpanel">';
                    html += renderWorkflowTimeline(data.workflow_snapshot);
                    html += '</div>';
                }
                html += '</div>';
            }

            $body.html(html);

            // Footer meta
            var footerParts = [];
            if (data.started_at && data.completed_at) {
                var start = new Date(data.started_at);
                var end = new Date(data.completed_at);
                var diff = Math.round((end - start) / 1000);
                footerParts.push('<i class="fad fa-stopwatch mr-1"></i>' + (diff > 0 ? diff + 's' : '<1s'));
            }
            footerParts.push('Execution #' + (data.id || '-'));
            $('#executionFooterMeta').html(footerParts.join(' &middot; '));

            $body.off('click', '.btn-toggle-response').on('click', '.btn-toggle-response', function() {
                var $target = $($(this).data('target'));
                $target.toggleClass('d-none');
                var isVisible = !$target.hasClass('d-none');
                $(this).html(isVisible ? '<i class="fad fa-eye-slash mr-1"></i>Hide Response' : '<i class="fad fa-eye mr-1"></i>View Response');
            });

            $body.off('click', '.btn-toggle-delayed-nodes').on('click', '.btn-toggle-delayed-nodes', function() {
                var $rows = $body.find('.delayed-node-row');
                $rows.toggleClass('d-none');
                var isVisible = !$rows.first().hasClass('d-none');
                $(this).html(isVisible
                    ? '<i class="fad fa-chevron-up mr-1"></i>Hide pending nodes'
                    : '<i class="fad fa-chevron-down mr-1"></i>Show pending nodes (' + $rows.length + ')');
            });

            $body.off('click', '.btn-toggle-wf-detail').on('click', '.btn-toggle-wf-detail', function() {
                var $target = $($(this).data('target'));
                $target.toggleClass('d-none');
                var isVisible = !$target.hasClass('d-none');
                $(this).html(isVisible ? '<i class="fad fa-caret-down mr-1"></i>Hide detail' : '<i class="fad fa-caret-right mr-1"></i>Show detail');
            });
        }).fail(function() {
            $body.html('<div class="alert alert-danger mb-0"><i class="fad fa-exclamation-triangle mr-1"></i> Failed to load execution details.</div>');
        });
    });

    $(document).on('click', '.btn-cancel-execution', function() {
        var url = $(this).data('url');
        showConfirmModal({
            icon: '<i class="fad fa-stop-circle"></i>',
            color: '#dc3545',
            title: 'Cancel Execution?',
            message: 'This will stop the currently running execution.',
            btnClass: 'btn-danger',
            btnText: 'Cancel Execution'
        }, function() {
            $.post(url, {_token: csrfToken}, function() { location.reload(); });
        });
    });

    $(document).on('click', '.btn-retry-execution', function() {
        var url = $(this).data('url');
        showConfirmModal({
            icon: '<i class="fad fa-redo-alt"></i>',
            color: '#007bff',
            title: 'Retry Execution?',
            message: 'This will re-run the automation with the original trigger data.',
            btnClass: 'btn-primary',
            btnText: 'Retry'
        }, function() {
            $.post(url, {_token: csrfToken}, function() { location.reload(); });
        });
    });

    $(document).on('click', '.btn-clear-history', function() {
        var url = $(this).data('url');
        showConfirmModal({
            icon: '<i class="fad fa-trash"></i>',
            color: '#dc3545',
            title: 'Clear Execution History?',
            message: 'This will permanently delete all execution records except currently running ones.',
            btnClass: 'btn-danger',
            btnText: 'Clear All'
        }, function() {
            $.ajax({url: url, type: 'DELETE', data: {_token: csrfToken}, success: function() { location.reload(); }});
        });
    });
});
